module.exports = __webpack_public_path__ + "static/media/window-maximize-symbolic.aa86fa21.svg";